<template>
  <div class="zpinfo" v-if="zp_info" :data-stat="zp_stat">
    <!--
      1.VIP，不用领取
      2.非VIP，已领取
      3.非VIP，已领光
      4.非VIP,未领取
    -->
    <div v-if="zp_stat===1">
      <img class="poster" :src="zp_info.vrs_data.imgurl" alt="">
      <img src="//vipcdn.mgtv.com/upload3/201810/20181025/zp2018/vip_tip.png" alt="" class="vip_tag">

      <div class="card">
        <img class="avatar" :src="zp_info.zpinfo.avatar" alt="">
        <div class="tip1">“{{zp_info.zpinfo.nickname}}”给您赠送了</div>
        <div class="tip2">《{{zp_info.zpinfo.part_name}}》<span class="tag">VIP</span></div>
        <div class="tip3">剩余{{remain_num}}个名额,先到先得哦!</div>
        <div class="countdown">{{count_down_time}}后过期</div>
        <div class="button" @click="toWatch('VIP用户-前往观看')">立刻观看</div>
      </div>
      <div class="vip_button" @click="toWatch('VIP用户-我也赠片')">
        我也要赠送影片
      </div>
      <div class="share_num">
        还有{{zp_info.zpinfo.share_num}}人也分享了该影片
      </div>
    </div>
    <!--已领取-->
    <div v-else-if="zp_stat===2">
      <img class="poster" :src="zp_info.vrs_data.imgurl" alt="">
      <div class="card">
        <img class="avatar" :src="zp_info.zpinfo.avatar" alt="">
        <div class="tip1">“{{zp_info.zpinfo.nickname}}”给您赠送了</div>
        <div class="tip2">《{{zp_info.zpinfo.part_name}}》<img
          src="//vipcdn.mgtv.com/upload3/201810/20181025/zp2018/viptag.png" class="tag"></div>
        <div class="tip3">剩余{{remain_num}}个名额,先到先得哦!</div>
        <div class="countdown">{{count_down_time}}后过期</div>
        <div class="button" @click="toWatch('领取用户-前往观看')">前往观看</div>
        <img src="//vipcdn.mgtv.com/upload3/201810/20181025/zp2018/get_tag.png" class="get_tag"/>
      </div>
      <div class="vip_button" @click="toBuy('成为VIP 免费看大片')">
        成为VIP 免费看大片
      </div>
      <div class="share_num">
        还有{{zp_info.zpinfo.share_num}}人也分享了该影片
      </div>
    </div>
    <!--已过期-->
    <div v-else-if="zp_stat===3">
      <img class="poster" :src="zp_info.vrs_data.imgurl" alt="">

      <div class="card">
        <img class="avatar" :src="zp_info.zpinfo.avatar" alt="">
        <div class="tip1">“{{zp_info.zpinfo.nickname}}”给您赠送了</div>
        <div class="tip2">《{{zp_info.zpinfo.part_name}}》<img
          src="//vipcdn.mgtv.com/upload3/201810/20181025/zp2018/viptag.png" class="tag"></div>
        <div class="tip3">剩余{{remain_num}}个名额,先到先得哦!</div>
        <div class="countdown">{{count_down_time}}后过期</div>
        <div class="button" style="color: #929292 !important;">赠片已过期</div>
      </div>
      <div class="vip_button" @click="toBuy('成为VIP 免费看大片')">
        成为VIP 免费看大片
      </div>
      <div class="share_num">
        还有{{zp_info.zpinfo.share_num}}人也分享了该影片
      </div>
    </div>
    <!--已领完-->
    <div v-else-if="zp_stat===4">
      <img class="poster" :src="zp_info.vrs_data.imgurl" alt="">

      <div class="card">
        <img class="avatar" :src="zp_info.zpinfo.avatar" alt="">
        <div class="tip1">“{{zp_info.zpinfo.nickname}}”给您赠送了</div>
        <div class="tip2">《{{zp_info.zpinfo.part_name}}》<img
          src="//vipcdn.mgtv.com/upload3/201810/20181025/zp2018/viptag.png" class="tag"></div>
        <div class="tip3">剩余{{remain_num}}个名额,先到先得哦!</div>
        <div class="countdown">{{count_down_time}}后过期</div>
        <div class="button" style="color: #929292 !important;">抢光啦！</div>
      </div>
      <div class="vip_button" @click="toBuy('成为VIP 免费看大片')">
        成为VIP 免费看大片
      </div>
      <div class="share_num">
        还有{{zp_info.zpinfo.share_num}}人也分享了该影片
      </div>

    </div>
    <!--其余的情况，可领取-->
    <div v-else>
      <img class="poster" :src="zp_info.vrs_data.imgurl" alt="">
      <div class="card">
        <img class="avatar" :src="zp_info.zpinfo.avatar" alt="">
        <div class="tip1">“{{zp_info.zpinfo.nickname}}”给您赠送了</div>
        <div class="tip2">《{{zp_info.zpinfo.part_name}}》<img
          src="//vipcdn.mgtv.com/upload3/201810/20181025/zp2018/viptag.png" class="tag"></div>
        <div class="tip3">剩余{{remain_num}}个名额,先到先得哦!</div>
        <div class="countdown">{{count_down_time}}后过期</div>
        <div class="button" @click="getRight">立刻领取</div>
      </div>
      <div class="share_num">
        还有{{zp_info.zpinfo.share_num}}人也分享了该影片
      </div>
    </div>
  </div>
  <div v-else class="zpinfo">

  </div>
</template>

<script>
  import {countDownFormt} from '../tools/time-format'
  import {getJSON} from '../api/myaxios'
  import click_handler from '../tools/mgtv/click'
  import {openSchema, openLink} from '../tools/mgtv/link'
  import {GET_ZP_INFO} from '../constant/eventbus'
  import to_casher from "../tools/mgtv/casher";

  let interval = null;

  function clearInterval() {
    if (interval !== null) {
      window.clearInterval(interval);
      interval = null
    }
  }

  export default {
    name: "ZPInfo",
    data() {
      return {
        countdown: 0
      }
    },
    created() {
      this.initCountDown();
    },
    beforeDestroy() {
      clearInterval();
    },
    computed: {
      zp_stat: function () {
        if(!this.zp_info){
          return -99
        }
        if (this.is_vip) {
          return 1 //会员
        } else if (this.countdown <= 0) {
          return 3 //已过期 （过期分两种，赠片过期，已领取但权益过期）
        } else if (this.my_prize) {
          return 2 //已领取
        } else if (this.remain_num <= 0) {
          return 4 //已领完
        }
        return 5 //可领取
      },
      zp_info: function () {
        return window.$bus.zp_info
      },
      remain_num() {
        return this.zp_info.zpinfo.total_num - this.zp_info.zpinfo.recv_num;
      },
      count_down_time() {
        return countDownFormt(this.countdown)
      },
      is_vip() {
        return window.$bus.user.vip_id > 0
      },
      my_prize() {
        if (this.zp_info.recv_list) {
          const res = this.zp_info.recv_list.find(item => {
            return item.is_self !== 0
          });
          console.log('my_prize', res);
          return res;
        }
        return null
      }
    },
    methods: {
      initCountDown() {
        //到时间有两种，1是观影卡倒计时，2是赠片倒计时
        if (this.zp_info) {
          let countdown = 0;
          if (this.my_prize) {
            countdown = this.my_prize.diff;
          } else {
            countdown = this.zp_info.zpinfo.diff;
          }
          this.startCountdown(countdown);
        }
      },
      startCountdown(countdown) {
        clearInterval();
        this.countdown = countdown;
        if (this.countdown > 0) {
          interval = setInterval(() => {
            if (this.countdown > 0) {
              this.countdown--;
            } else {
              clearInterval();
            }
          }, 1000);
        }
      },
      getRight() {
        click_handler('领取权益', () => {
          getJSON('//vipact3.api.mgtv.com/api/v1/zp/zp/recv', {
            act_name: window.rootdata.act_name,
            ticket: window.$bus.user.ticket,
            share_id: window.gact.share_id
          }).then(res => {
            if (res.ret === 0) {
              let message = `<div style="text-align: left;font-size:.3rem;color:#666;margin-bottom:.2rem">&nbsp;&nbsp;&nbsp;&nbsp;观影权益已生效，将于<span style="font-size:.3rem;color:red">${this.count_down_time}</span>后过期，请打开芒果TV观看</div>`;
              window.$act_alert_dialog.show({
                title: message,
                button: "立即观看"
              }).then(() => {
                this.toWatch('弹窗-立刻观看');
              })
              window.$bus.$emit(GET_ZP_INFO);
            }
            else {
              window.$toast(res.msg);
              // window.$toast('领取失败，请重试');
            }
          })
        }, {
          need_login: true,
          need_act: true,
          need_vip: false
        })
      },
      toWatch(eventName) {
        const schema = this.zp_info.schema;
        click_handler(eventName, () => {
          // openSchema(schema)
          openLink("https://club.mgtv.com/activity/2020/zengpianlist/index.html");
        }, {
          need_login: false,
          need_act: false,
          need_vip: false
        })
      },
      toBuy(eventName){
        click_handler(eventName, () => {
          to_casher()
        }, {
          need_login: false,
          need_act: false,
          need_vip: false
        })
      }
    },
    watch: {
      zp_info: function (val) {
        if (val) {
          this.initCountDown();
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  @import "../share/mixins.styl"
  .zpinfo
    position relative
    background url("https://vipcdn.mgtv.com/upload3/201810/20181025/zp2018/head.png") no-repeat
    background-size 100% auto

    width 7.5rem
    padding-top 5.94rem
    .poster
      width 3.16rem
      position relative
      hcenter()
      top .66rem
      z-index 1
    .vip_tag
      position absolute
      width 4.19rem
      hcenter()
      top 4.4rem
      z-index 2

    .card
      position relative
      background url("https://vipcdn.mgtv.com/upload3/201810/20181025/zp2018/card.png") no-repeat
      background-size cover
      width 7.01rem
      height 3.32rem
      margin 0 auto
      .avatar
        position absolute
        width 1rem
        border-radius 1rem
        top -.5rem
        hcenter()
      .tip1
        font-size .28rem
        color white
        padding-top .62rem
        text-align center
      .tip2
        color: #ffd65b;
        font-size .32rem
        text-align center
        padding-top .1rem
        display flex
        align-items center
        justify-content center
        font-weight bold
        .tag
          display inline-block
          height .27rem
      .get_tag
        position absolute
        width 1.4rem
        top 1.3rem
        right .15rem

      .tip3
        text-align center
        color white
        font-size .28rem
        padding-top .1rem
      .countdown
        color: #ffffff;
        font-size .24rem
        text-align center
        padding-top .1rem
        opacity .8
      .button
        position absolute
        bottom 0
        text-align center
        height .9rem
        line-height @height
        width 100%
    .vip_button
      position relative
      width 7rem
      height .88rem
      background url(https://vipcdn.mgtv.com/upload3/201810/20181025/zp2018/large_button.png) no-repeat
      background-size cover
      line-height @height
      text-align center
      margin .2rem auto 0
      color: #452213
      font-size .34rem

    .share_num
      text-align center
      color: #a985e1;
      font-size .28rem
      width 100%
      height .6rem
      line-height @height


</style>



// WEBPACK FOOTER //
// src/components/ZPInfo.vue